module.exports = __webpack_public_path__ + "7f3c53e67bb8d9cfe5c55164b66db19e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003BVA.png
// module id = 1525
// module chunks = 0